<events
    [userInfo]="userInfo"
    [isViewer]="isViewer">
</events>